<template>
  <v-col cols="12" class="py-1" :align="item.food.name === 'empty' ? 'center' : 'start'">
    <v-sheet color="#fafafa" class="px-2 py-4" style="border-radius: 8px">
      <v-row
        no-gutters
        :justify="item.food.name === 'empty' ? 'center' : 'space-between'"
      >
        <v-col>
          <span
            :class="{'empty-placeholder': item.food.name === 'empty'}"
            class="food-box-name"
          >
            {{
              item.food.name === "empty"
                ? "izaberite " + item.category
                : toLatin(item.food.name)
            }}
          </span>
        </v-col>
        <v-col cols="auto" v-if="!checkDisabled && item.food.name !== 'empty'">
          <circle-button @click="deselectFood(item)" icon="mdi-close"></circle-button>
        </v-col>
      </v-row>
    </v-sheet>
  </v-col>
</template>

<script>
export default {
  props: {
    item: Object,
    checkDisabled: Boolean,
  },
  methods: {
    deselectFood(item) {
      this.$emit("deselect-food", item);
    },
  },
};
</script>

<style scoped>
.empty-placeholder {
  color: rgba(0, 0, 0, 0.38) !important;
}
</style>
